module.exports = __webpack_public_path__ + "static/media/MagnifyingGlass.be6e89a6.svg";